import { ReferenceItem } from './reference-item';

class ReferenceMenu {
  constructor(references) {
    this.referenceItems = references.map(r => new ReferenceItem(r));
  }
}

export { ReferenceMenu };
